// FT-PRICING-UI: shared upsell card. Used inline wherever a feature
// is gated on the pro plan — chat-turn cap, account page, future
// gated tabs.

import { useState } from "preact/hooks";

export function UpgradePrompt({ reason }: { reason: string }) {
  const [busy, setBusy] = useState(false);
  const upgrade = async () => {
    setBusy(true);
    try {
      const res = await fetch("/api/billing/checkout", { method: "POST" });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        alert(
          data.error === "billing not configured"
            ? "Billing isn't configured on this server yet."
            : "Couldn't start checkout — try again in a moment.",
        );
        return;
      }
      window.location.href = data.redirect_url;
    } finally {
      setBusy(false);
    }
  };
  return (
    <div class="alert alert-warning d-flex flex-column gap-2 mb-0">
      <div class="fw-medium">{reason}</div>
      <div class="small text-muted">
        Pro is $12/mo. Unlimited portals, far more AI chat turns, plus
        analytics, contact form, custom embeds, and AI image/video generation as
        those features land.
      </div>
      <button
        type="button"
        class="btn btn-warning btn-sm align-self-start"
        onClick={upgrade}
        disabled={busy}
      >
        {busy ? "Starting…" : "Upgrade to Pro"}
      </button>
    </div>
  );
}
